import CtaBanner from "@/components/site/CtaBanner";

const INDUSTRIES = [
  {
    name: "Manufacturing",
    img: "https://images.unsplash.com/photo-1781156215907-e3b8da4091b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtYW51ZmFjdHVyaW5nJTIwZmFjaWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM1Nzc4NTZ8MA&ixlib=rb-4.1.0&q=85",
    body: "Steady daytime loads from machinery and compressed air often line up well with solar generation, especially when paired with battery to cover peak demand periods.",
  },
  {
    name: "Warehousing",
    img: "https://images.unsplash.com/photo-1776179806507-b70623e680a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBleHRlcmlvcnxlbnwwfHx8fDE3ODM1Nzc4NTZ8MA&ixlib=rb-4.1.0&q=85",
    body: "Large roof footprints and extended trading hours can make warehouses well suited to a solar-and-battery PPA structure.",
  },
  {
    name: "Cold storage & food processing",
    img: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxzdXBlcm1hcmtldCUyMGFpc2xlfGVufDB8fHx8MTc4MzU3Nzg1Nnww&ixlib=rb-4.1.0&q=85",
    body: "Continuous refrigeration means high, stable loads that benefit from consistent on-site generation and battery-backed evening cover.",
  },
  {
    name: "Supermarkets & grocery",
    img: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxzdXBlcm1hcmtldCUyMGFpc2xlfGVufDB8fHx8MTc4MzU3Nzg1Nnww&ixlib=rb-4.1.0&q=85",
    body: "Refrigeration, lighting and HVAC combine into a high daytime and evening load — a common fit for solar plus battery.",
  },
  {
    name: "Clubs & sporting facilities",
    img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaG9zcGl0YWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM1Nzc4Njd8MA&ixlib=rb-4.1.0&q=85",
    body: "Evening and weekend operating patterns make battery storage an important part of the design for many clubs and community facilities.",
  },
  {
    name: "Childcare & education",
    img: "https://images.unsplash.com/photo-1775037467144-cbfbc85881a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjaGlsZGNhcmUlMjBjZW50ZXIlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODM1Nzc4NTZ8MA&ixlib=rb-4.1.0&q=85",
    body: "Consistent daytime operating hours align well with solar generation, and predictable long-term occupancy suits a PPA term.",
  },
  {
    name: "Medical & healthcare",
    img: "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzU3Nzg1Nnww&ixlib=rb-4.1.0&q=85",
    body: "Medical centres and clinics often run high HVAC and equipment loads — cleaner on-site energy can reduce grid exposure over the long term.",
  },
  {
    name: "Hospitality",
    img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaG9zcGl0YWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM1Nzc4Njd8MA&ixlib=rb-4.1.0&q=85",
    body: "Kitchen equipment, refrigeration and long trading hours mean hospitality sites often benefit from solar plus battery storage.",
  },
  {
    name: "Commercial property owners",
    img: "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzU3Nzg1Nnww&ixlib=rb-4.1.0&q=85",
    body: "Landlords can add a solar-and-battery asset to their site without upfront capital and provide cleaner energy to tenants.",
  },
  {
    name: "Retail centres",
    img: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxzdXBlcm1hcmtldCUyMGFpc2xlfGVufDB8fHx8MTc4MzU3Nzg1Nnww&ixlib=rb-4.1.0&q=85",
    body: "Common-area lighting, HVAC and tenant loads create a stable demand profile suitable for a usage-based commercial PPA.",
  },
];

export default function Industries() {
  return (
    <div>
      <section className="container-x mx-auto max-w-7xl pt-14 md:pt-24 pb-10" data-testid="industries-hero">
        <div className="max-w-3xl">
          <p className="text-forest text-xs tracking-[0.18em] uppercase font-semibold mb-4">Industries we work with</p>
          <h1 className="font-heading text-4xl md:text-6xl font-semibold text-forest leading-[1.03] tracking-tight">
            Solar and battery PPAs built for real commercial operations.
          </h1>
          <p className="mt-6 text-neutral-600 text-lg leading-relaxed">
            Every site is different — but there are common patterns of load, roof space and operating
            hours where a no-upfront commercial PPA tends to fit particularly well.
          </p>
        </div>
      </section>

      <section className="container-x mx-auto max-w-7xl pb-16 md:pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((it, i) => (
            <article
              key={it.name}
              className="group rounded-2xl overflow-hidden bg-white border border-black/5 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300"
              data-testid={`industry-card-${i}`}
            >
              <div className="h-40 overflow-hidden">
                <img src={it.img} alt={it.name} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-lg font-semibold text-forest">{it.name}</h3>
                <p className="mt-2 text-[14.5px] text-neutral-600 leading-relaxed">{it.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <CtaBanner
        testId="industries-cta"
        title="Not sure if your site fits?"
        body="Submit an application and our team will assess your load, site and ownership structure."
        ctaLabel="Start online application"
      />
    </div>
  );
}
